var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInteraccion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20944",
    "data-name": "Group 20944",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.439,
    height: 63.252,
    viewBox: "0 0 37.439 63.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7654",
    "data-name": "Path 7654",
    d: "M26.86,55.868l-9.276-.029c-2.63-.222-6.151-3.984-7.744-5.868L7.015,46.324,2.1,38.922c-.547-.892-2.229-3.249-2.09-4.341.06-.491.84-1.164,1.215-1.428a5.866,5.866,0,0,1,6.715.275,15.863,15.863,0,0,1,2.805,3.328L10.727,13.21a9.507,9.507,0,0,1,.027-1.147A3.473,3.473,0,0,1,13.786,8.97l.672-.014A3.452,3.452,0,0,1,17.535,11.7a12.988,12.988,0,0,1,.072,2.206v8.712c0,1.162.031,2.331-.044,3.487,1.116-3.6,5.732-3.387,6.478-.13a8.007,8.007,0,0,1,.133.989,3.774,3.774,0,0,1,.967-1.61,3.444,3.444,0,0,1,4.7.28c.969,1.062.918,2.367.86,3.721.756-2.625,3.623-3.6,5.594-1.653a3.975,3.975,0,0,1,1.131,2.967V44.943a18.425,18.425,0,0,1-.152,3.073c-.472,2.825-1.918,6.833-4.984,7.691a10.492,10.492,0,0,1-2.779.168Z",
    transform: "translate(0 7.349)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7655",
    "data-name": "Path 7655",
    d: "M26.4,24.093a1.66,1.66,0,0,1-1.174-2.834,10.513,10.513,0,1,0-14.867,0,1.66,1.66,0,1,1-2.347,2.348,13.833,13.833,0,1,1,19.563,0,1.655,1.655,0,0,1-1.174.486",
    transform: "translate(-3.967 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInteraccion);
export default __webpack_public_path__ + "static/media/icon_interaccion.f0dc7b2b9265a49919142aca137a6318.svg";
export { ForwardRef as ReactComponent };